import {ApplicationConfig, APP_INITIALIZER, LOCALE_ID, importProvidersFrom} from '@angular/core'
import {IonicStorageModule, Storage} from '@ionic/storage-angular'
import {InterceptorService} from './core/http/interceptor.service'
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http'
import {provideIonicAngular, IonicRouteStrategy} from '@ionic/angular/standalone'
import {RouteReuseStrategy, provideRouter} from '@angular/router'
import {appRoutes} from './app.routes'
import {registerLocaleData} from '@angular/common'
import localeEs from '@angular/common/locales/es'

import {RuntimeConfigService} from "@/app/core/config/runtime-config.service";
import { ErpCacheInvalidationInterceptor } from '@/app/domains/erp/shared/data-access/erp-cache-invalidation.interceptor'
import { BACK_BUTTON_ICON } from '@/app/core/platform/navigation-chrome'
import { HttpBackend, HttpClient } from '@angular/common/http'
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { DEFAULT_LANGUAGE, LanguageService } from '@/app/core/i18n/language.service'

registerLocaleData(localeEs, 'es')

export function initRuntimeConfig(cfg: RuntimeConfigService) {
    return () => cfg.load()
}

export function initStorage(storage: Storage) {
    return () => storage.create()
}

/**
 * Textos de la app por idioma: assets/i18n/{es,en,pt}.json (ver core/i18n/language.service.ts).
 * Se piden SIN interceptores (HttpBackend): son archivos estáticos que no llevan token, y el español se pide apenas se crea
 * TranslateService, antes de que exista el Storage que lee InterceptorService ("Database not created"): esa petición fallaba
 * y la app quedaba mostrando claves en español.
 */
export function translateHttpLoader(handler: HttpBackend) {
    return new TranslateHttpLoader(new HttpClient(handler), './assets/i18n/', '.json')
}

export function initLanguage(language: LanguageService) {
    return () => language.init()
}

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            IonicStorageModule.forRoot()
        ),
        {provide: LOCALE_ID, useValue: 'es'},
        {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: APP_INITIALIZER,
            useFactory: initRuntimeConfig,
            deps: [RuntimeConfigService],
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initStorage,
            deps: [Storage],
            multi: true,
        },
        // Idioma (es/en/pt, elegido en Perfil): el primer render ya sale traducido.
        provideTranslateService({
            defaultLanguage: DEFAULT_LANGUAGE,
            loader: { provide: TranslateLoader, useFactory: translateHttpLoader, deps: [HttpBackend] },
        }),
        {
            provide: APP_INITIALIZER,
            useFactory: initLanguage,
            deps: [LanguageService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErpCacheInvalidationInterceptor,
            multi: true,
        },
        // Botón volver estándar: solo ícono (chevron en teléfono/tablet, flecha en web) — ver navigation-chrome.ts
        provideIonicAngular({ backButtonText: '', backButtonIcon: BACK_BUTTON_ICON }),
        provideRouter(appRoutes),
    ],
}
